import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IInterventionRemark } from "../../utils/types/models";

export default createEntityReducer<IInterventionRemark>(Endpoint.InterventionRemarks);
